import WebLayout from "../layout/WebLayout";
import { FaRupeeSign } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import PrimaryCartButton from "../components/button/PrimaryCartButton";
import { useCartFetch } from "../hooks/useCartFetch";
import { useSelector } from "react-redux";
import CartRemove from "../components/button/CartRemove";
import {
  defaultProductImage,
  MSME_USER_ORDER_DETAILS,
} from "../utils/Constants";
import React, { useState } from "react";
import { removeCookie, storeCookie } from "../utils/CookieAction";

function Cart() {
  const navigate = useNavigate();
  const { cartList, minimumOrderAmount, username } = useSelector(
    (state) => state.cart,
  );

  const [error, setError] = useState(null);

  const { storeCity } = useSelector((state) => state.auth);

  useCartFetch(storeCity);

  let cartTax = 0;
  let subTotal = 0;
  let cartTotalPrice = 0;
  let cartTotalQty = 0;
  let taxAmount = 0;

  const placeOrder = () => {
    if (Number(cartTotalPrice) < Number(minimumOrderAmount)) {
      setError(
        `Your cart amount is below the minimum order value of ₹${minimumOrderAmount}. Please add more items to continue.`,
      );
      return false;
    }

    storeCookie(
      MSME_USER_ORDER_DETAILS,
      JSON.stringify({
        subTotal,
        cartTotalPrice,
        cartTotalQty,
        cartTax,
        taxAmount,
      }),
    );
    navigate("/checkout", { replace: true });
  };
  if (!cartList.length && username) {
    removeCookie(MSME_USER_ORDER_DETAILS);
    window.location.href = `https://indianmsme.org/${username}`;
  }

  return (
    <WebLayout pageName={Cart}>
      <section className="cart py-20">
        <div className="container container-lg">
          <div className="row">
            <div className="mb-10 d-flex justify-content-between align-items-center">
              {cartList.length > 0 && username ? (
                <Link
                  to={`https://indianmsme.org/${username}`}
                  className="btn btn-info  py-12 px-24 rounded-5 flex-center gap-8 fw-medium"
                >
                  <b>View Seller Products</b>
                  <span className="text-xl d-flex text-white">
                    {" "}
                    <i className="ph ph-storefront"></i>
                  </span>
                </Link>
              ) : null}

              {cartList.length > 0 && username ? (
                <h6 className="text-danger">
                  The minimum order amount is {minimumOrderAmount}
                </h6>
              ) : null}
            </div>
          </div>
          {cartList.length > 0 ? (
            <div className="row gy-4">
              <div className="col-xl-12 col-lg-12 text-center mb-0">
                {error && <h6 className={"text-danger fw-bold"}>{error}</h6>}
              </div>
              <div className="col-xl-8 col-lg-8 mt-0">
                <div className="cart-table border border-gray-100 rounded-8 px-20 py-20">
                  <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                    {cartList.length > 0 &&
                      cartList.map((item, index) => {
                        cartTotalPrice += item.sell_price * item.qty;
                        cartTotalQty += item.qty;

                        taxAmount =
                          parseFloat(item.seller_tax_amount) +
                          parseFloat(item.company_tax_amount);

                        cartTax += parseFloat(
                          (taxAmount * Number(item.qty)).toFixed(2),
                        );

                        subTotal = parseFloat(
                          (cartTotalPrice - cartTax).toFixed(2),
                        );

                        return (
                          <div className="d-flex gap-24 my-5" key={index}>
                            <img
                              src={item.product_image}
                              className="border"
                              alt={item.product_name}
                              onError={(event) => {
                                event.target.src = defaultProductImage;
                                event.onerror = null;
                              }}
                              style={{ width: 150, height: 150 }}
                            />

                            <div className="text-start">
                              <h6 className="title text-lg fw-semibold mb-8">
                                {item.product_name}{" "}
                                <span className="bg-warning-600  text-sm text-white px-4 rounded-1">
                                  MOQ:
                                  {item.min_sale_qty}Pc
                                </span>
                              </h6>

                              <div className="flex-align gap-16">
                                <PrimaryCartButton
                                  cartQty={item.qty}
                                  minQty={item.min_sale_qty}
                                  maxQty={item.max_sale_qty}
                                  cartId={item.id}
                                  productId={item.product_id}
                                />
                                X
                                <div
                                  style={{
                                    fontSize: 16,
                                    fontWeight: "bold",
                                  }}
                                >
                                  <FaRupeeSign />
                                  {Number(item.sell_price)?.toFixed(2)}
                                </div>
                                =
                                <div
                                  style={{
                                    fontSize: 16,
                                    fontWeight: "bold",
                                  }}
                                >
                                  <FaRupeeSign />
                                  {item.totalPrice?.toFixed(2)}
                                </div>
                              </div>
                              <div className={"mt-5"}>
                                <CartRemove cartId={item.id} qty={item.qty} />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 mt-0">
                <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-24">
                  <h6 className="text-xl">PRICE DETAILS</h6>
                  <div className="bg-color-three rounded-8 p-20">
                    <div className="flex-between align-items-center">
                      <h6 style={{ fontSize: 16 }}>Total Items</h6>
                      <span className="text-gray-900 fw-semibold">
                        <span>{cartTotalQty}</span>
                      </span>
                    </div>

                    <div className="flex-between align-items-center">
                      <h6 style={{ fontSize: 16 }}>Subtotal</h6>
                      <span className="text-gray-900 fw-semibold">
                        <FaRupeeSign />
                        <span>{(cartTotalPrice - cartTax)?.toFixed(2)}</span>
                      </span>
                    </div>

                    <div className="flex-between align-items-center">
                      <h6 style={{ fontSize: 16 }}>Taxes</h6>
                      <span className="text-gray-900 fw-semibold">
                        <FaRupeeSign />
                        <span>{cartTax?.toFixed(2)}</span>
                      </span>
                    </div>
                  </div>
                  <div className="bg-color-three rounded-8 p-20 mt-20">
                    <div className="flex-between gap-8">
                      <span className="text-gray-900 text-xl fw-semibold">
                        <strong>Total</strong>
                      </span>
                      <span className="text-gray-900 text-xl fw-semibold">
                        <FaRupeeSign />
                        {cartTotalPrice?.toFixed(2)}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={placeOrder}
                    className="btn btn-main mt-20 py-18 w-100 rounded-8"
                  >
                    <strong>PROCEED TO CHECKOUT</strong>
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className={"text-center"}>
              <div className="p-2 items-center justify-center flex">
                <img src={require("../assets/images/cart_empty.png")} alt="" />
              </div>
              <h1 className={"font-bold text-2xl"}>Your cart is empty</h1>
              <h3 className={"font-semibold text-gray-500"}>
                Looks like you haven't added any product to your cart yet.
              </h3>
              <button
                className="btn btn-success mt-2 rounded-full"
                onClick={() => navigate("/")}
              >
                Continue Shopping
              </button>
            </div>
          )}
        </div>
      </section>
    </WebLayout>
  );
}

export default Cart;
